// @flow
import React from "react";
import { useSelector } from "react-redux";

import { isEmpty } from "ramda";

import { type ErrosSelecao } from "../../../../model";

import {
  type State,
  comGeradorDePeriodo,
  getAtivosCarteiraSelecionados,
  getCamposSelecionados,
  i18n,
  getAjusteDiasSelecionado,
  isModoSeries,
  analiseValorDaMedida,
} from "../../../../state";

import {
  SelecaoAtivo,
  SelecaoCampos,
  SelecaoPeriodo,
  SelecaoAjusteDias,
  SelecaoCasasDecimais,
} from "../../configuracoes";

import { randomId } from "../../../../util";

export const criaFuncaoValidacaoPontualMensalAtivoComprado = (
  state: State
) => (): ?ErrosSelecao => {
  const erros: ErrosSelecao = {};
  const { translate } = i18n(state);

  if (isEmpty(getCamposSelecionados(state)))
    erros.campoNaoSelecionado = translate(
      "configuracaoRelatorio.erroMedidaSemCampoSelecionado"
    );

  if (isEmpty(getAtivosCarteiraSelecionados(state)))
    erros.ativoNaoSelecionado = translate(
      "configuracaoRelatorio.erroMedidaSemAtivoSelecionado"
    );

  return erros;
};

export const processarPontualMensalAtivoComprado = comGeradorDePeriodo(
  (state, medidas) => {
    const campos = new Set(getCamposSelecionados(state));
    const ativos = getAtivosCarteiraSelecionados(state);
    const ajusteDias = getAjusteDiasSelecionado(state);
    const modoSeries = isModoSeries(state);
    const idGrupoMedidasSelecionadas = randomId();

    if (modoSeries) {
      return ativos.flatMap(({ id, nome }) =>
        medidas
          .filter(medidasSelecionada =>
            campos.has(medidasSelecionada.medida.codigoOriginal)
          )
          .map(medidasSelecionada => ({
            ...medidasSelecionada,
            idGrupoMedidasSelecionadas,
            idAtivoComprado: id,
            nomeAtivoComprado: nome,
            ...analiseValorDaMedida(medidasSelecionada, state),
          }))
      );
    } else {
      return ativos.flatMap(({ id, nome }) =>
        medidas
          .filter(medidasSelecionada =>
            campos.has(medidasSelecionada.medida.codigoOriginal)
          )
          .map(medidasSelecionada => ({
            ...medidasSelecionada,
            idGrupoMedidasSelecionadas,
            idAtivoComprado: id,
            nomeAtivoComprado: nome,
            ajusteDias,
            ...analiseValorDaMedida(medidasSelecionada, state),
          }))
      );
    }
  }
);

const PontualMensalAtivoComprado = () => {
  const modoSeries = useSelector(isModoSeries);

  if (modoSeries) {
    return (
      <>
        <div className="ConfiguracaoMedida">
          <SelecaoAtivo />
        </div>

        <div className="ConfiguracaoMedida__vertical-divider" />

        <div className="ConfiguracaoMedida">
          <SelecaoCampos />
        </div>
      </>
    );
  } else {
    return (
      <div className="ConfiguracaoMedida--no-flex">
        <div className="ConfiguracaoMedida--row">
          <SelecaoAtivo />
          <SelecaoCasasDecimais />
        </div>

        <div className="ConfiguracaoMedida__horizontal-divider" />

        <div className="ConfiguracaoMedida--row">
          <div className="ConfiguracaoMedida--flex">
            <SelecaoPeriodo exibirPeriodicidade={false} />
          </div>

          <div className="ConfiguracaoMedida">
            <div className="ConfiguracaoMedida__box">
              <SelecaoAjusteDias />
            </div>
          </div>

          <div className="ConfiguracaoMedida__vertical-divider" />

          <div className="ConfiguracaoMedida">
            <SelecaoCampos />
          </div>

          <div className="ConfiguracaoMedida__vertical-divider" />
        </div>
      </div>
    );
  }
};

export default PontualMensalAtivoComprado;
